import React, { useState } from "react";
import tw from "twin.macro";
import { isMobile } from 'react-device-detect';

export const NavLink = tw.a`no-underline text-black hover:bg-[#faeae2] p-2 hover:text-black block  hover:(-translate-y-2 bg-custom-200) duration-300 transition ease-in-out delay-150 hover:shadow-lg`;

export default function CallSupport({ mobile }) {
  const [isOpen, setIsOpen] = useState(false);
  const handleClick = () => {
    if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
      window.location.replace(`tel:${mobile}`);
    } else if (window.matchMedia("(max-width: 425px)").matches || isMobile) {
      window.location.href = `tel:${mobile}`;
    } else {
      console.log(mobile, "website");
      setIsOpen(true);
    }
  };
  const handleClose = () => {
    setIsOpen(false);
  };
  return (
    <div>
      <div tw="mr-[5px] flex items-center justify-center sm:justify-between text-xs sm:text-sm lg:text-xs xl:text-sm relative cursor-pointer" onClick={handleClick}>
        <i className="bi bi-phone"></i>
      </div>
      {isOpen && (
        <div tw="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-50 mt-[-10px]">
          <div tw="bg-white rounded-lg p-4 w-1/4 flex flex-col items-center -mt-40">
            <p tw="text-lg mb-4">Calls are not supported on website.</p>
            <button className="rounded-pill shadow-sm" tw="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded" onClick={handleClose} >
              OK 
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
